import React, { useRef } from 'react';
var VeltNotificationsPanelContentPeopleListItemCount = function (props) {
    var data = props.data, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-people-list-item-count", { ref: ref, data: data ? (typeof data === "string" ? data : JSON.stringify(data)) : undefined }, children));
};
export default VeltNotificationsPanelContentPeopleListItemCount;
